import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'Application',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Application',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Application',
    column_type: 'datetime',
  },
  name: {
    model_name: 'Application',
    column_type: 'string',
  },
  desc: {
    model_name: 'Application',
    column_type: 'string',
  },
  share_desc: {
    model_name: 'Application',
    column_type: 'string',
  },
  share_title: {
    model_name: 'Application',
    column_type: 'string',
  },
  wechat_application: {
    model_name: 'Application',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'wechat_application',
      model_name: 'BsWechatMiniProgram::Application',
      foreign_key: 'wechat_application_id',
    },
  },
  wechat_application_id: {
    model_name: 'Application',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'wechat_application',
      model_name: 'BsWechatMiniProgram::Application',
      foreign_key: 'wechat_application_id',
    },
  },
  customer_service_phone: {
    model_name: 'Application',
    column_type: 'string',
  },
  customer_service_wechat: {
    model_name: 'Application',
    column_type: 'string',
  },
  wechat_audit_user_id: {
    model_name: 'Application',
    column_type: 'integer',
  },
  application_admin_users_role_id: {
    model_name: 'Application',
    column_type: 'string',
  },
  share_image: {
    model_name: 'Application',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  logo: {
    model_name: 'Application',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  creator: {
    model_name: 'Application',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'creator',
      model_name: 'AdminUser',
      foreign_key: 'creator_id',
    },
  },
  creator_id: {
    model_name: 'Application',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'creator',
      model_name: 'AdminUser',
      foreign_key: 'creator_id',
    },
  },
  poster_image: {
    model_name: 'Application',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  risk_warning: {
    model_name: 'Application',
    column_type: 'text',
  },
}

export const columnsExtend = (columns, filterColumnsExtend) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
